function groupPhoneDigits(digits = '') {
  return String(digits || '')
    .replace(/\D/g, '')
    .replace(/(\d{2})(?=\d)/g, '$1 ')
    .trim();
}

function sanitizePhoneDraft(value = '') {
  const raw = String(value || '');
  if (!raw) return '';

  let next = raw.replace(/[^\d+\s()-]/g, '');
  const firstPlusIndex = next.indexOf('+');

  if (firstPlusIndex > 0) {
    next = next.replace(/\+/g, '');
  } else if (firstPlusIndex === 0) {
    next = `+${next.slice(1).replace(/\+/g, '')}`;
  } else {
    next = next.replace(/\+/g, '');
  }

  return next.replace(/\s{2,}/g, ' ');
}

function normalizePhoneNumber(value = '', countryCode = '+216') {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const normalizedCountryCode = String(countryCode || '+216').trim() || '+216';
  const countryDigits = normalizedCountryCode.replace(/\D/g, '');

  let digits = raw.replace(/[^\d+]/g, '');
  if (!digits) return '';

  if (digits.startsWith('+')) {
    const compactDigits = digits.slice(1).replace(/\D/g, '');
    if (!compactDigits) return '';
    if (compactDigits.startsWith(countryDigits)) {
      const rest = compactDigits.slice(countryDigits.length);
      return rest ? `+${countryDigits} ${groupPhoneDigits(rest)}` : `+${countryDigits}`;
    }
    return `+${groupPhoneDigits(compactDigits)}`;
  }

  digits = digits.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith(countryDigits)) {
    const rest = digits.slice(countryDigits.length);
    return rest ? `+${countryDigits} ${groupPhoneDigits(rest)}` : `+${countryDigits}`;
  }

  if (digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  const groupedDigits = groupPhoneDigits(digits);
  return groupedDigits ? `${normalizedCountryCode} ${groupedDigits}` : normalizedCountryCode;
}

function getPhoneDigits(value = '') {
  return String(value || '').replace(/\D/g, '');
}

function isValidPhoneNumber(value = '', countryCode = '+216') {
  const digits = getPhoneDigits(normalizePhoneNumber(value, countryCode));
  return digits.length >= 8 && digits.length <= 15;
}

module.exports = {
  getPhoneDigits,
  isValidPhoneNumber,
  normalizePhoneNumber,
  sanitizePhoneDraft,
};
